export default "__VITE_ASSET__C31Dkz0w__"